import { createMachine } from 'xstate';

import {
  FormMachine,
  DefaultContext,
  DefaultActions,
  DefaultGuards,
  DefaultInitialState,
  DefaultMachineId,
} from './machine-config';
import { defaultConfig } from '../core/default-config';

export const createFormMachine = ({
  machineId,
  initialState,
  context: overrideContext,
  guards: overrideGuards,
  actions: overrideActions,
}) => {
  const machine = {
    ...FormMachine,
    id: machineId || DefaultMachineId,
    initial: initialState || DefaultInitialState,
    context: {
      ...DefaultContext,
      ...overrideContext,
      config: {
        ...defaultConfig,
        ...(overrideContext ? overrideContext.config : {}),
      },
    },
  };

  // Below options can also be overridden thru useInterpret options
  const options = {
    actions: {
      ...DefaultActions,
      ...overrideActions,
    },
    guards: {
      ...DefaultGuards,
      ...overrideGuards,
    },
  };
  return createMachine(machine, options);
};
